import { AxiosResponse } from "axios";
import BaseAPI from "../api";

const path: string = "report";

type employeeTableType = {
  lang: "eng" | "th";
  search?: string;
  nationality?: string;
  gender?: string;
  position?: number;
  department?: number;
  status?: string;
  sortType?: string;
  sortBy?: string;
  limit?: number;
  page?: number;
  type?: string;
};

export type complaintReport = {
  id_complaints_type?: number;
  keyword?: string;
  start_date?: string;
  end_date?: string;
  complaints_status?: string;
}
export type complaintTypeReport = {
  keyword?: string;
  status?: string;
}

export type report_file_data_e_library = {
  page?: number;
  limit?: number;
  sortBy?: string;
  sortType?: string;
  search?: string;
  action?: string;
  start_date?: string;
  end_date?: string;
  library_category_name?: string;
  type_user?: number
  type_file?: string;
}
export type report_file_period_data_e_library = {
  page?: number;
  limit?: number;
  sortBy?: string;
  sortType?: string;
  start_date?: string;
  end_date?: string;
  type: string;
  type_file?: string;
}

export interface LeaveReportQuery {
  id_leave_type?: number;                // รหัสประเภทการลา
  leave_start_date?: string;             // วันที่เริ่มลา (ISO datetime)
  leave_end_date?: string;               // วันที่สิ้นสุดลา (ISO datetime)

  leave_approve_first?: number;          // รหัสผู้อำนวยการเบื้องต้น
  leave_approve_second?: number;         // รหัสผู้อำนวยการลำดับที่สอง
  leave_approve_third?: number;          // รหัสตรวจสอบลำดับที่สาม

  leave_status?: string;
  // สถานะการอนุมัติ

  created_id?: number;                   // ผู้สร้าง
  created_date?: string;                 // วันที่สร้าง (ISO datetime)
  modified_id?: number;                  // ผู้แก้ไข
  modified_date?: string;                // วันที่แก้ไข (ISO datetime)

  limit?: number;                        // จำนวนต่อหน้า (default 10)
  page?: number;                         // หน้าที่แสดง (default 1)
  type_file?: string;                    // ประเภทไฟล์ (pdf, excel, etc.)
  keyword?: string;
}


export class ReportApi extends BaseAPI {
  static GetEmployeeTable(query: employeeTableType): Promise<any> {
    return this.api.get(`${path}/employee-table`, {
      params: { ...query },
      responseType: "arraybuffer",
    });
  }

  static GetLoginLogoutLog(query: employeeTableType): Promise<any> {
    return this.api.get(`${path}/login-out-log`, {
      params: { ...query },
      responseType: "arraybuffer",
    });
  }

  static GetCheckInCheckOut(query: employeeTableType): Promise<any> {
    return this.api.get(`${path}/check-in-out`, {
      params: { ...query },
      responseType: "arraybuffer",
    });
  }

  static GetCheckInCheckOutByEmployeeId(
    query: employeeTableType,
    employee_id: number
  ): Promise<any> {
    return this.api.get(`${path}/check-in-out/by-employee/${employee_id}`, {
      params: { ...query },
      responseType: "arraybuffer",
    });
  }

  static downloadReportAdvisorstudent(query?: employeeTableType): Promise<any> {
    return this.api.get(`${path}/advisor-student`, {
      params: { ...query },
      responseType: "arraybuffer",
    });
  }

  static export_pdf(id: number, token: string, query: any): Promise<any> {
    return this.api.get(`${path}/consulting-report/${id}/pdf/${token}`, {
      params: {
        ...query,
      },
      headers: { Authorization: `Bearer ${token}` },
      responseType: "arraybuffer",
    });
  }


  static downloadCourseStudentEstimate(id_course_annual: number, query?: employeeTableType): Promise<any> {
    return this.api.get(`${path}/${id_course_annual}/course-student-estimate`, {
      params: { ...query },
      responseType: "arraybuffer",
    });
  }

  static downloadEstimateCourseByIdCourseStudyAndIdEmployee(id_course_study: number, id_employee: number, query?: employeeTableType): Promise<any> {
    return this.api.get(`${path}/${id_course_study}/estimate-course/${id_employee}`, {
      params: { ...query },
      responseType: "arraybuffer",
    });
  }

  // ระบบร้องเรียน
  static complaintReport(query: complaintReport): Promise<any> {
    return this.api.get(`${path}/complaints`, { params: { ...query }, responseType: 'arraybuffer' })
  }
  static complaintTypeReport(query: complaintTypeReport): Promise<any> {
    return this.api.get(`${path}/complaints_type`, { params: { ...query }, responseType: 'arraybuffer' })
  }
  static logThesis(query?: any): Promise<any> {
    return this.api.get(`${path}/log-thesis`, {
      params: { ...query },
      responseType: "arraybuffer",
    });
  }



  // E-library
  static logELibraryData(params: report_file_data_e_library): Promise<AxiosResponse> {
    return this.api.get(`${path}/e-library/log-usage`, {
      params: params,
      responseType: "arraybuffer"
    })
  }
  static logELibraryPeriod(params: report_file_period_data_e_library): Promise<AxiosResponse> {
    return this.api.get(`${path}/e-library/log-usage-chart`, {
      params: params,
      responseType: "arraybuffer"
    })
  }


  // leave-management
  static reportLeaveManagement(params: LeaveReportQuery): Promise<AxiosResponse> {
    return this.api.get(`${path}/leave-management`, { params, responseType: "arraybuffer" })
  }
  static reportLeaveListEmployee(params: LeaveReportQuery): Promise<AxiosResponse> {
    return this.api.get(`${path}/leave-list-employee`, { params, responseType: "arraybuffer" })
  }


  static reportLogThesis(params: any): Promise<AxiosResponse> {
    return this.api.get(`${path}/log-thesis`, { params, responseType: "arraybuffer" })
  }



  //report leave management
  static reportLeaveManagementById(id_leave: number): Promise<AxiosResponse> {
    return this.api.get(`${path}-pdf/${id_leave}`, { responseType: "arraybuffer" })
  }
}
